export const AssistanceTemplate = (rowData: any) => {
  const assistance = !!rowData.assistance || false;
  return (
    <div className="flex flex-column gap-1">
      {assistance ? (
        <span className="text-sm text-color-secondary inline-block">
          <i className="pi pi-check mr-1 text-xs text-green-500 rounded-full"></i>
          Asistió
        </span>
      ) : (
        <span className="text-sm text-color-secondary inline-block">
          <i className="pi pi-times mr-1 text-xs text-red-500 rounded-full"></i>
          No asistió
        </span>
      )}
    </div>
  );
};
